// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".video_player{width:100%;height:100%;border:1px solid #ccc}.xgplayer-skin-default .xgplayer-volume .xgplayer-icon{bottom:14px!important}.xgplayer-icon-pause svg{bottom:0}.xgplayer-icon{margin-top:-20px!important}", ""]);
// Exports
exports.locals = {
	"g_main_sidebar_width": "60px",
	"g_sub_sidebar_width": "193px",
	"g_sidebar_width": "253px",
	"g_app_bg": "#fff",
	"g_main_bg": "#f5f7f9",
	"g_header_bg": "#222b45",
	"g_header_menu_color": "#fff",
	"g_header_menu_active_bg": "rgb(50.8349514563,64.2912621359,103.1650485437)",
	"g_main_sidebar_bg": "#2e3056",
	"g_main_sidebar_menu_color": "#fff",
	"g_main_sidebar_menu_active_bg": "hsla(0,0%,100%,.33)",
	"g_sub_sidebar_bg": "#fff",
	"g_sub_sidebar_menu_color": "#37414b",
	"g_sub_sidebar_menu_active_color": "#e7f4ff",
	"g_sub_sidebar_menu_active_bg": "#ecf2fa"
};
module.exports = exports;
